import { buildCsv } from './downloadOriginCsv';
import { PAID_DUE_COLUMNS } from './downloadReportCatalog';

export { buildCsv };

export const paidDueCsvFileName = (from, to) => {
  const safePart = value => String(value || '').replace(/:/g, '-');
  return `paid-due-${safePart(from)}-to-${safePart(to)}.csv`;
};

export const paidDueCsvMetricCells = (metrics = {}) =>
  PAID_DUE_COLUMNS.map(column => metrics[column] ?? 0);
